import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicStoreRoute from '../../components/PublicStoreRoute';
import StoreLayout from './layout';
import HomePage from './pages/home';
import CartPage from './pages/cart';
import CheckoutPage from './pages/checkout';
import CheckoutSuccessPage from './pages/checkout-success';
import ContactPage from './pages/contact';
import ProductPage from './pages/product';
import ProductsPage from './pages/products';

export default function StoreRoutes() {
  return (
    <Routes>
      <Route element={
        <PublicStoreRoute>
          <StoreLayout />
        </PublicStoreRoute>
      }>
        <Route index element={<HomePage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="product/:productId" element={<ProductPage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
